export default () => {
  return (
    <div className="container-fluid my-5 py-5 text-center">
      <h1>404: Page Not Found</h1>
    </div>
  );
};
